const CommonSidebar = () => import(/* webpackChunkName: "component.header" */ '@/components/Sidebar');
const CommonHeader = () => import(/* webpackChunkName: "component.header" */ '@/components/Header');
const CommonFooter = () => import(/* webpackChunkName: "component.header" */ '@/components/Footer');

export default {
  path: 'users',
  components: {
    sidebar: CommonSidebar,
    header: CommonHeader,
    footer: CommonFooter,
    default: () => import(/* webpackChunkName: "module.users" */ '@/views/Users'),
  },
  meta: {
    breadcrumb: {
      label: 'Users',
    },
  },
  children: [
    {
      path: '',
      name: 'users-listing',
      component: () => import(/* webpackChunkName: "module.users.list" */ '@/modules/Users/List'),
      meta: {
        breadcrumb: {
          label: 'Users',
        },
      },
    },
    {
      path: ':id/edit',
      name: 'users-edit',
      component: () => import(/* webpackChunkName: "module.users.edition" */ '@/modules/Users/Edition'),
      meta: {
        breadcrumb: {
          parent: 'users-listing',
          label: 'Edit User',
        },
      },
    },
    {
      path: 'create',
      name: 'users-create',
      component: () => import(/* webpackChunkName: "module.users.edition" */ '@/modules/Users/Add'),
      meta: {
        breadcrumb: {
          parent: 'users-listing',
          label: 'Create User',
        },
      },
    },
  ],
};
